const socketMiddleware = (socket) => (store) => (next) => (action) => {
  const { branchId, restaurantId, id } = store.getState().user;
  const channels = [id, branchId];
  // const { enableKDS } = store.getState().util;

  if (action.isSocket) {
    if (Boolean(id)) {
      if (socket.connected === false) {
        socket.on("connect", async () => {
          // socket.emit("JOIN_ROOM", channel);
          channels.forEach((channel) => {
            socket.emit("JOIN_ROOM", channel);
          });
          socket.emit("GET_ORDERS", {
            branchId,
            restaurantId,
            userId: id,
          });
          // socket.disconnect();
          socket.emit(action.type, {
            branchId,
            restaurantId,
            userId: id,
            ...action.payload,
          });
        });

        // console.log("socket emit", action.type);
      }
      // if (enableKDS && Boolean(branchId)) {
      //   if (socket.connected === false) {
      //     socket.on("connect", async () => {
      //       socket.emit("JOIN_ROOM", branchId);
      //       socket.emit("GET_ORDERS", {
      //         branchId,
      //         restaurantId,
      //       });
      //       // socket.disconnect();
      //       socket.emit(action.type, {
      //         branchId,
      //         restaurantId,
      //         userId: id,
      //         ...action.payload,
      //       });
      //     });

      //     // console.log("socket emit", action.type);
      //   }
      else {
        // console.log("socket emit", action.type);
        // socket.emit("JOIN_ROOM", channel);
        channels.forEach((channel) => {
          socket.emit("JOIN_ROOM", channel);
        });
        socket.emit(action.type, {
          branchId,
          restaurantId,
          userId: id,
          ...action.payload,
        });
      }
    } else {
      next(action);
    }
  } else {
    next(action);
  }
};
export default socketMiddleware;
